export default __webpack_public_path__ + "static/media/udskæring-gamle-dage.7dcd6cac.jpg";